export const createBreakpointOptions = (tokens) => {
    const { core: { breakpoints: { mobile, tablet, desktop }, }, } = tokens;
    return {
        values: {
            sm: parseInt(mobile.min.value),
            md: parseInt(tablet.min.value),
            lg: parseInt(desktop.min.value),
        },
    };
};
//# sourceMappingURL=breakpoints.js.map